import { QuoteBus } from './QuoteBus'
import { QuoteNoteBus } from "./QuoteNoteBus";
import { QuoteInvoiceBus } from "./QuoteInvoiceBus";
import { AttachmentBus } from "./AttachmentBus";
import { v_QuoteEquipmentBus } from "./v_QuoteEquipmentBus";

export class QuoteSaveParam extends QuoteBus {
    constructor(data: QuoteBus) {
        super(data);
    }
    public lineItems: QuoteInvoiceBus[];
    public notes: QuoteNoteBus[];
    public attachments: AttachmentBus[];
    public equipment: v_QuoteEquipmentBus[];
}

